import { useMemo } from "react";
import { useSchedulerStore } from "../state/scheduler.store";
import { computeSelectedSlotISO } from "../utils/slotTime";

export const useSelectedSlot = () => {
  const { sessionData } = useSchedulerStore();

  const currentlySelectedSlot = useMemo(() => {
    if (
      !Number.isInteger(sessionData?.selectedSlot?.hour) ||
      (sessionData?.selectedSlot?.hour ?? -1) < 0 ||
      !sessionData?.selectedTimezone
    ) {
      return null;
    }
    return computeSelectedSlotISO(
      sessionData.selectedSlot!.date,
      sessionData.selectedSlot!.hour!,
      sessionData.selectedSlot!.minute ?? 0,
      sessionData.selectedTimezone
    );
  }, [sessionData?.selectedSlot, sessionData?.selectedTimezone]);

  return currentlySelectedSlot;
};
